// İSG uzmanı portalı — Kullanıcılar (Users) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("users", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useUsersAccess) sonucuna göre Kullanıcılar alt-ağacını (Outlet:
// liste), 403 sayfasını veya "kullanılamıyor" durumunu gösterir. Ayarlar/Admin/iş modülü
// kapılarıyla aynı desen; tenant kullanıcı yönetimi olarak AYRIDIR.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { TriangleAlert, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useUsersAccess } from '../../lib/usersAccess';

export function UsersGate() {
  const { t } = useTranslation();
  const access = useUsersAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('users.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <Users className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('users.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('users.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('users.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('users.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('users.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('users.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
